import { render, staticRenderFns } from "./Berechnung.vue?vue&type=template&id=78893bb8"
import script from "./Berechnung.vue?vue&type=script&lang=js"
export * from "./Berechnung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports